module.exports = __webpack_public_path__ + "static/media/dataDownloadGY.5ed11431.md";